import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';
import { getPageWidth } from '../utils/JsUtils';
import { css } from '../utils/CssUtils';

export default class Dock extends AbstractComponent {
    constructor(...args) {
        Logger.log('Dock->constructor()');
        super(...args);

        this.initDomElements();
        this.addEventListeners();
        this.updateHeight();
    }

    initDomElements() { }

    addEventListeners() {
        this.boundResizeListener = this.app.on('resize', this.updateHeight.bind(this));
    }

    updateHeight() {
        let dockHeight = this.$el.getBoundingClientRect().height;
        if (this.app.isBreakpointUp('md')) {
            const dockRatioWidth = 3 * 16;
            const dockRatioHeight = 9;
            dockHeight = getPageWidth() * dockRatioHeight / dockRatioWidth;
            const dockMaxHeight = 272;
            if (dockHeight > dockMaxHeight) {
                dockHeight = dockMaxHeight;
            }
            css(this.$el, { 'height': dockHeight + 'px' });
        } else {
            css(this.$el, { 'height': null });
        }
        this.app.emit('dock-height-update', dockHeight);
    }

    destroy() { }
}